import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchAccount } from "views/account/_actions"


class Dashboard extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="dash-wrapper d-flex align-items-center justify-content-center">
        <h1>This is the dashboard</h1>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, { fetchAccount })(Dashboard);



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js